import { createElement } from 'react'
import type { RouteObject } from 'react-router-dom'
import { Layout } from '~/components/Layout'
import { RootRedirect } from '~/pages/RootRedirect'
import { AssessmentPage } from '~/pages/AssessmentPage'
import { ResultsPage } from '~/pages/ResultsPage'
import { SignupPage } from '~/pages/SignupPage'
import { LoginPage } from '~/pages/LoginPage'
import { ForgotPasswordPage } from '~/pages/ForgotPasswordPage'
import { ResetPasswordPage } from '~/pages/ResetPasswordPage'
import { DashboardPage } from '~/pages/DashboardPage'
import { DeeperInsightsPlaceholderPage } from '~/pages/DeeperInsightsPlaceholderPage'
import { ComputingResultsPage } from '~/pages/ComputingResultsPage'
import { RevealPage } from '~/pages/RevealPage'
import { TipsPage } from '~/pages/TipsPage'
import { PerspectivesPage } from '~/pages/PerspectivesPage'
import { ProfilePage } from '~/pages/ProfilePage'
import { ChangePasswordPage } from '~/pages/ChangePasswordPage'
import { VerifyEmailPage } from '~/pages/VerifyEmailPage'
import { PortraitOnboardingPage } from '~/pages/PortraitOnboardingPage'
import { PortraitCelebrationPage } from '~/pages/PortraitCelebrationPage'
import { AskDynamoPage } from '~/pages/AskDynamoPage'

export const routes: RouteObject[] = [
  {
    element: createElement(Layout),
    children: [
      { path: '/', element: createElement(RootRedirect) },
      { path: '/assessment', element: createElement(AssessmentPage) },
      { path: '/assessment/results', element: createElement(ComputingResultsPage) },
      { path: '/assessment/reveal', element: createElement(RevealPage) },
      { path: '/results', element: createElement(ResultsPage) },
      { path: '/signup', element: createElement(SignupPage) },
      { path: '/verify-email', element: createElement(VerifyEmailPage) },
      { path: '/login', element: createElement(LoginPage) },
      { path: '/forgot-password', element: createElement(ForgotPasswordPage) },
      { path: '/reset-password', element: createElement(ResetPasswordPage) },
      { path: '/dashboard', element: createElement(DashboardPage) },
      { path: '/onboarding/portrait', element: createElement(PortraitOnboardingPage) },
      { path: '/onboarding/portrait/celebrate', element: createElement(PortraitCelebrationPage) },
      { path: '/ask-dynamo', element: createElement(AskDynamoPage) },
      { path: '/tips', element: createElement(TipsPage) },
      { path: '/perspectives', element: createElement(PerspectivesPage) },
      { path: '/profile', element: createElement(ProfilePage) },
      { path: '/change-password', element: createElement(ChangePasswordPage) },
      { path: '/deeper-insights', element: createElement(DeeperInsightsPlaceholderPage) },
    ],
  },
]
